export default __webpack_public_path__ + "static/media/rope.6cf66874.svg";